<!-- ReservationIcon.vue -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M19.6206 17.3945H5.3786C4.38692 17.3945 3.58301 18.1984 3.58301 19.1901V19.1915C3.58301 20.1832 4.38692 20.9871 5.3786 20.9871H19.6206C20.6122 20.9871 21.4162 20.1832 21.4162 19.1915V19.1901C21.4162 18.1984 20.6122 17.3945 19.6206 17.3945Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M19.6206 13.8008H5.3786C4.38692 13.8008 3.58301 14.6047 3.58301 15.5964V15.5978C3.58301 16.5895 4.38692 17.3934 5.3786 17.3934H19.6206C20.6122 17.3934 21.4162 16.5895 21.4162 15.5978V15.5964C21.4162 14.6047 20.6122 13.8008 19.6206 13.8008Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M19.6206 10.209H5.3786C4.38692 10.209 3.58301 11.0129 3.58301 12.0046V12.006C3.58301 12.9977 4.38692 13.8016 5.3786 13.8016H19.6206C20.6122 13.8016 21.4162 12.9977 21.4162 12.006V12.0046C21.4162 11.0129 20.6122 10.209 19.6206 10.209Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M16.4403 6.61719H8.56055"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M10.4903 12.6152H14.5093C14.9934 12.6152 15.3859 13.0077 15.3859 13.4919V20.8323H9.6123V13.4919C9.6123 13.0077 10.0047 12.6152 10.4889 12.6152H10.4903Z"
      fill="currentColor"
    />
    <path
      d="M1.74414 13.1201L11.4604 3.40387C12.0067 2.85757 12.8918 2.85757 13.4367 3.40387L23.256 13.2232"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M21.4941 4.37695V11.397"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>
